/** @format */

import { ReactComponent as Bank } from '../../assets/icons/bank.svg';
import { ReactComponent as Card } from '../../assets/icons/card.svg';
import { ReactComponent as Mobile } from '../../assets/icons/mobile.svg';
import { ReactComponent as Wallet } from '../../assets/icons/wallet.svg';
import { ReactComponent as Kuda } from '../../assets/icons/kuda.svg';
import { ReactComponent as Transfer } from '../../assets/icons/transfer.svg';
import { ReactComponent as USSD } from '../../assets/icons/ussd.svg';
import { ReactComponent as Mono } from '../../assets/icons/mono.svg';
import { ReactComponent as Mpesa } from '../../assets/icons/M-Pesa.svg';
import { ReactComponent as MobileSSL } from '../../assets/icons/mobile-ssl.svg';


const methodKeyToLogo = {
	mono: <Mono />,
	card: <Card />,
	transfer: <Transfer />,
	ussd: <USSD />,
	wallet: <Wallet />,
	kuda: <Kuda />,
	mpesa: <Mpesa />,
	cellulant: <Mobile />,
	mobileeast: <Mobile />,
	stitch: <Bank />,
	business: <Wallet />,
    mobile: <MobileSSL  />
};

const methodKeyToName = {
	mono: 'Mono',
	transfer: 'Bank transfer',
	card: 'Card',
	ussd: 'USSD',
	wallet: 'Klasha wallet',
	kuda: 'Kuda',
	mpesa: 'M-PESA',
	cellulant: 'Cellulant',
	stitch: 'Bank',
	mobileeast: 'Mobile money',
	business: 'Business wallet',
    mobile: 'Mobile money'
};

export { methodKeyToLogo, methodKeyToName };
